import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "text", "form"]
  
  connect() {
    this.isDownloading = false
    
    // Set up an iframe for the download to handle the response
    this.setupDownloadFrame()
    
    // Reset button if page is refreshed while in downloading state
    if (this.isDownloading) {
      this.resetButton()
    }
  }
  
  disconnect() {
    // Clean up when controller is disconnected
    if (this.downloadFrame && document.body.contains(this.downloadFrame)) {
      document.body.removeChild(this.downloadFrame)
    }
    
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout)
    }
  }
  
  setupDownloadFrame() {
    // Create hidden iframe to handle the download
    this.downloadFrame = document.createElement('iframe')
    this.downloadFrame.style.display = 'none'
    document.body.appendChild(this.downloadFrame)
    
    // When iframe loads, it means response was received
    this.downloadFrame.addEventListener('load', () => {
      // Reset after a small delay to ensure download started
      setTimeout(() => this.resetButton(), 500)
    })
  }
  
  startDownload(event) {
    // Prevent default form submission
    event.preventDefault()
    
    // If already downloading, do nothing
    if (this.isDownloading) return
    
    console.log("Download started")
    this.isDownloading = true
    
    // Show spinner
    if (this.hasIconTarget) {
      this.originalIcon = this.iconTarget.className
      this.iconTarget.className = "spinner-border spinner-border-sm me-2"
      this.iconTarget.setAttribute("role", "status")
    }
    
    // Update text
    if (this.hasTextTarget) {
      this.originalText = this.textTarget.innerText.trim()
      this.textTarget.innerText = "Downloading..."
    }
    
    // Get the download URL from the form
    const url = this.formTarget.getAttribute('action')
    
    // Use the iframe to request the file
    this.downloadFrame.src = url
    
    // Safety timeout in case iframe load event doesn't fire
    this.resetTimeout = setTimeout(() => this.resetButton(), 5000)
  }
  
  resetButton() {
    // Only reset if currently downloading
    if (!this.isDownloading) return
    
    console.log("Resetting button")
    this.isDownloading = false
    
    // Reset icon
    if (this.hasIconTarget && this.originalIcon) {
      this.iconTarget.className = this.originalIcon
      this.iconTarget.removeAttribute("role")
    }
    
    // Reset text
    if (this.hasTextTarget && this.originalText) {
      this.textTarget.innerText = this.originalText
    }
    
    // Clear timeout if it exists
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout)
      this.resetTimeout = null
    }
  }
}